export const state = {
  programs: [],
  isLoading: false,
  totalRecords: 0,
  programPerPage: 10000,
  activePage: 1
}
